<template>
  <div class="page" :class="{ 'animate-flicker': loading }">
    <div>
      <h2>Data Purchase Order</h2>

      <br />

      <div class="btn-bar">
        <router-link
          to="/transaksi/pembelian/-1"
          class="btn-fill btn-width-auto"
        >
          Tambah Pembelian
        </router-link>
        <button
          type="button"
          class="btn-outline btn-search"
          @click="toggleFilter"
        >
          <close v-if="showFilter" />
          <search v-if="!showFilter" />
        </button>

        <div class="filter" v-show="showFilter">
          <div class="filter-body">
            <form @submit.prevent="loadData()">
              <div class="form-group">
                <label>No PO</label>
                <input type="text" v-model="filter.no_po" />
              </div>
              <div class="form-group trx-po">
                <label>Tgl Pembelian</label>
                <date-range-picker v-model="dateRange">
                  <template v-slot:input="picker">
                    {{ moment(picker.startDate).format("DD MMM YYYY") }} -
                    {{ moment(picker.endDate).format("DD MMM YYYY") }}
                  </template>
                </date-range-picker>
              </div>
              <div class="form-group">
                <label>Supplier</label>
                <input type="text" v-model="filter.supplier" />
              </div>
              <div class="form-group">
                <label>Pembayaran</label>
                <select v-model="filter.pembayaran">
                  <option value="SEMUA">Semua</option>
                  <option value="LUNAS">Lunas</option>
                  <option value="BELUM_LUNAS">Belum Lunas</option>
                </select>
              </div>
              <button type="submit" class="btn btn-fill">FILTER</button>
            </form>
          </div>
        </div>
      </div>

      <div class="table-wrapper">
        <table class="table">
          <thead>
            <tr>
              <th>No</th>
              <th>No PO</th>
              <th>Tgl PO</th>
              <th>Supplier</th>
              <th>Grand Total</th>
              <th>Pembayaran</th>
              <th>Kurang Bayar</th>
              <th>Keterangan</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in data"
              :key="index"
              @click="$router.push('/transaksi/pembelian/' + item.id)"
            >
              <td>{{ ++index }}</td>
              <td>{{ item.no_po }}</td>
              <td>{{ moment(item.tanggal).format("DD/MM/YYYY") }}</td>
              <td>{{ item.supplier || "-" }}</td>
              <td>Rp {{ item.total | number }}</td>
              <td>
                {{
                  parseInt(item.total_bayar) >= parseInt(item.total)
                    ? "Lunas"
                    : ("Rp " + item.total_bayar) | number
                }}
              </td>
              <td>Rp {{ (item.total - item.total_bayar) | number }}</td>
              <td>{{ item.keterangan }}</td>
              <td>
                <span @click.stop="confirmHapus(item)" class="btn-hapus"
                  >Hapus</span
                >
              </td>
            </tr>
            <tr v-show="data.length <= 0 && !loading" class="no-hover">
              <td colspan="7">
                <p style="text-align: center; padding-top: 100px">
                  Tidak ada data
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment from "moment";

import * as api from "../../api/Api";
import Search from "./../icons/Search.vue";
import Close from "./../icons/Close.vue";

export default {
  name: "BahanBaku",
  components: {
    Search,
    Close,
    DateRangePicker,
  },
  data() {
    return {
      loading: false,
      data: [],
      dateRange: {
        startDate: moment().format("YYYY-MM-01"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      filter: {
        tgl_awal: moment().format("YYYY-MM-01"),
        tgl_akhir: moment().format("YYYY-MM-DD"),
      },
      showFilter: false,
    };
  },
  methods: {
    moment,
    toggleFilter() {
      this.showFilter = !this.showFilter;
    },
    loadData() {
      this.loading = true;

      this.filter.tgl_awal = moment(this.dateRange.startDate).format(
        "YYYY-MM-DD"
      );
      this.filter.tgl_akhir = moment(this.dateRange.endDate).format(
        "YYYY-MM-DD"
      );

      const filter = this.$objectToQuery(this.filter);
      this.showFilter = false;

      api
        .get("/v4/pembelian?id_toko=" + this.$toko.id + "&" + filter)
        .then((r) => {
          this.data = r.data;
          this.loading = false;

          // this is for PO form page
          this.$store.commit("barang/save", r.bahan_baku);
          this.$store.commit("supplier/save", r.supplier);
        })
        .catch((e) => {
          this.loading = false;
          this.$toast("Gagal mengambil data. Silakan coba lagi");
        });
    },
    confirmHapus(item) {
      if (confirm("Hapus PO-" + item.no_po + "?")) {
        api.post("/v4/pembelian/delete", item).then((r) => {
          this.$toast("Berhasil dihapus");
          this.loadData();
        });
      }
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style scoped lang="scss">
.page {
  > div {
    margin: 20px;
  }
  h2 {
    margin: 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
  }

  .btn-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;

    .btn-search {
      width: 50px;
      padding: 0;
      height: 42px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .filter {
      position: absolute;
      background: #ffff;
      right: 0;
      top: 50px;
      z-index: 2;
      border: 1px solid #ddd;
      border-radius: 5px;
      box-shadow: 3px 3px 5px #ccc;
      .filter-body {
        margin: 20px;

        form {
          width: 250px;
        }
      }
    }
  }

  .table-wrapper {
    margin-top: 15px;
    height: calc(100vh - 270px);
  }

  .modal {
    position: fixed;
    margin: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    .modal-body {
      background: #fff;
      width: 800px;
      height: 500px;
      padding: 20px;
      margin-top: 100px;
      border-radius: 7px;
      overflow: auto;
      h3 {
        margin: 0;
      }
      a {
        color: var(--primary);
        text-decoration: none;
        &:hover {
          font-weight: bold;
        }
      }
      input {
        width: auto;
      }
      .button-bar {
        display: flex;
        justify-content: space-between;
        margin: 15px 0 10px;
      }

      table {
        tr.animate-flicker {
          font-weight: bold;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.trx-po {
  .daterangepicker.openscenter {
    transform: translateX(-432px) !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/transaksi/Pembelian.vue